import $ from 'jquery'

export default {
    name: 'import-excel-modal',
    components: {},
    props: {
        dispatch_action: String,
        emit_action: String,
        type_prestation: String,
		modal_toggler: Boolean
    },
    data() {
        return {
            files: [],
			is_loading: false,
			is_error: false,
			msg_error: ''
        }
    },

	watch: {
		modal_toggler() {
			this.files = []
			this.is_error = false
			this.msg_error = ''
		}
	},

    computed: {

    },

    mounted() {

    },

    methods: {
        handleFilesUpload(event) {
			this.msg_error = ''
			$('.err-msg').fadeOut()
			let uploadedFiles = this.$refs.files.files;

			console.log(event);
			console.log(typeof uploadedFiles);
			/*
			  Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}
		},


		importFile() {
			this.msg_error = ''
			this.is_loading = true

			let formData = new FormData();
			$('.err-msg').fadeOut()

			let err = 0

			if (this.files.length == 0) {
				err++
			}

			if (err == 0) {
				formData.append('file', this.files[0]);
				formData.append('type_prestation', this.dispatch_action);

				this.$store.dispatch('importPrestation', { 'data': formData }).then((response) => {
					if (response.success) {
						this.files = []
						var preview = document.getElementById('upfile'+this.dispatch_action);
						preview.value = "";

						this.$refs.excel_modal.click()

						this.successToast("Importation effectuée avec succès");
						this.$emit(this.emit_action, response.count_distinct_rows)
					} else {
						this.msg_error = "Une erreur s'est produite lors de l'importation du fichier. Veuillez vérifier le format du fichier et réessayer."
					}
					
					this.is_loading = false
				}).catch(() => {
					this.is_error = true
					this.is_loading = false
					this.msg_error = "Une erreur s'est produite lors de l'importation. Merci de réessayer plus tard."
				})
			} else {
				// Afficher un message informant l'utilisateur de choisir un fichier
				$('.err-msg').fadeIn(500)
				this.is_loading = false
			}
		},
    }
}